import React from "react";
import TaskRunner from "../../components/TaskRunner/TaskRunner";
import {
  generateTasks,
  renderTask,
  renderInput,
  checkAnswer,
  renderAnswer,
  renderExplanation
} from "../../generators/dzial2_algebra/temat2_rownania/podtemat1_liniowe";

export default function Lesson2_Tasks({ hideUtilityFabs = false } = {}) {
  return (
    <TaskRunner
      sectionTitle="Zadania: Równania liniowe"
      generateTasks={generateTasks}
      renderTask={renderTask}
      renderInput={renderInput}
      checkAnswer={checkAnswer}
      renderAnswer={renderAnswer}
      renderExplanation={renderExplanation}
      hideUtilityFabs={hideUtilityFabs}
    />
  );
}
